import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const isSupabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);

if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-console
  console.log('[Supabase] configured:', isSupabaseConfigured);
}

export const supabase = isSupabaseConfigured
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: { persistSession: false },
    })
  : null;

function friendly(err) {
  if (!err) return 'Unknown error';
  const msg = err.message || String(err);
  if (msg.includes('row-level security') || err.code === '42501') {
    return 'Database is rejecting the submission (RLS). Run the policy SQL in Supabase.';
  }
  if (msg.includes('Failed to fetch') || msg.includes('NetworkError')) {
    return 'Network error reaching Supabase. Check your internet / project URL.';
  }
  return msg.replace(/^TypeError:\s*/, '');
}

export async function submitLead(payload) {
  if (!isSupabaseConfigured || !supabase) {
    return {
      ok: false,
      error: 'Form is not connected to a database yet. Please email us instead.',
    };
  }

  try {
    // No .select() so we don't double-read the response body on errors
    const { error } = await supabase.from('leads').insert([
      {
        name: payload.name,
        email: payload.email,
        website: payload.website || null,
        services: payload.services || [],
        timeline: payload.timeline || null,
        challenge: payload.challenge || null,
        budget: payload.budget || null,
        source: 'elevatenext-landing',
      },
    ]);

    if (error) {
      // eslint-disable-next-line no-console
      console.error('[Supabase] insert error:', error);
      return { ok: false, error: friendly(error) };
    }

    return { ok: true };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[Supabase] exception:', e);
    return { ok: false, error: friendly(e) };
  }
}
